import React, { useState, Fragment, useEffect } from "react";
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
} from "@material-ui/core";
import Stepper from "../../../../components/Stepper";
import $ from "jquery";
import ErrorPopUp from "../../../../components/ErrorPopUp";
import { BraintreePaypal } from "../../../../assets/js/braintreePaypal";
import { useSelector } from "react-redux";
import exit from "../../../../assets/images/exit.svg";

const PaymentStepTwo = (props) => {
	const {
		handleClose,
		handleNext,
		handleBack,
		activeStep,
		t,
		paymentSubmit,
		paymentURL,
		dataForRedirection,
		amount,
		callLoginInit,
		paypalInitData,
		paypalLoginInitData,
		paypalSubmit,
		getPaypalInit,
		errorSubmitPaypal,
		paypalSubmitData,
		getDataPaymentPaypal,
		errorPaypalGetData,
		getPaymentPaypalData,
		hideGoBackForTourist,
	} = props;
	const [choiceOfPayment, setChoiceOfPayment] = useState("");
	const [paypalInit, setPaypalInit] = useState({});
	const [paypalLogInitData, setPaypalLoginInitData] = useState({});
	const [errorPopUpOpen, setErrorPopUpOpen] = useState(false);
	const [receiptEmail, setReceiptEmail] = useState("");

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);
	const isLoadingSubmit = useSelector((state) => state.PaymentReducer.loading);
	const isValidReceiptEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
		receiptEmail.trim(),
	);
	const isSubmitDisabled =
		isLoadingSubmit || (isTourist && !isValidReceiptEmail);

	useEffect(() => {
		// Tourist flow doesn't show PayPal option, so avoid initializing PayPal UI.
		if (!isTourist) getPaypalInit();
	}, [isTourist, getPaypalInit]);

	useEffect(() => {
		window.addEventListener("pageshow", function (event) {
			const historyTraversal =
				event.persisted ||
				(typeof window.performance !== "undefined" &&
					window.performance.navigation.type === 2);
			if (historyTraversal) {
				// Handle page restore.
				window.location.reload();
			}
		});
	}, []);

	useEffect(() => {
		if (isTourist) return;
		if (Object.keys(paypalInitData).length !== 0) {
			setPaypalInit(paypalInitData);
		}
		if (paypalInitData.paypalEligible === false) {
			document.getElementById("paypalDiv").style.display = "none";
			BraintreePaypal.init(
				"NO_PAYPAL_PAYMENT_ALLOWED",
				"paypalLoginButton",
				paypalInitData.key,
				paypalInitData.flowId,
				paypalInitData.paypalSaveEnabled,
				paypalInitData.paypalClientToken,
			);
		} else if (
			paypalInitData.paypalSaveEnabled === true &&
			paypalInitData.paypalEligible === true &&
			paypalInitData.vault === null
		) {
			BraintreePaypal.init(
				"VAULT_CREATION_PAYPAL_PAYMENT_ALLOWED",
				"paypalLoginButton",
				paypalInitData.key,
				paypalInitData.flowId,
				paypalInitData.paypalSaveEnabled,
				paypalInitData.paypalClientToken,
				amount,
			);
		} else if (
			paypalInitData.paypalSaveEnabled === true &&
			paypalInitData.paypalEligible === true &&
			Object.keys(paypalInitData.vault).length !== 0
		) {
			sessionStorage.setItem("vaultId", paypalInitData.vault.vaultId);
			sessionStorage.setItem("vaultEmail", paypalInitData.vault.paypalEmail);
			BraintreePaypal.init(
				"VAULTED_PAYPAL_PAYMENT_ALLOWED",
				"paypalLoginButton",
				paypalInitData.key,
				paypalInitData.flowId,
				paypalInitData.paypalSaveEnabled,
				paypalInitData.paypalClientToken,
				amount,
				paypalInitData.vault.paypalEmail,
				t("captionManageButtonPaypal"),
				t("deleteVaultMessage"),
				t("confirm"),
				t("yes"),
				t("no"),
			);
		} else if (paypalInitData.paypalEligible === true) {
			BraintreePaypal.init(
				"NON_VAULTED_PAYPAL_PAYMENT_ALLOWED",
				"paypalLoginButton",
				paypalInitData.key,
				paypalInitData.flowId,
				paypalInitData.paypalSaveEnabled,
				paypalInitData.paypalClientToken,
				amount,
			);
		}
	}, [paypalInitData, isTourist]);

	useEffect(() => {
		// Prevent PayPal from being selected (and submitted) in tourist mode.
		if (isTourist) setChoiceOfPayment("newCard");
	}, [isTourist]);

	useEffect(() => {
		if (
			errorSubmitPaypal ||
			errorPaypalGetData ||
			getPaymentPaypalData.success === false
		) {
			setErrorPopUpOpen(true);
		}
	}, [errorSubmitPaypal, errorPaypalGetData]);

	useEffect(() => {
		if (paypalLoginInitData) {
			setPaypalLoginInitData(paypalLoginInitData);
			document.querySelector("#payPalTransactionId").innerText =
				paypalLoginInitData.transactionToken;
		}
		// if (choiceOfPayment === 'paypal' && document.querySelector('#paypal_login_completed').innerHTML!=='true') {
		//     document.getElementById('errorPaypalModal').style.display = 'block';
		// }
	}, [paypalLoginInitData]);

	useEffect(() => {
		if (paymentURL?.paymentUrl) {
			window.location.replace(paymentURL.paymentUrl);
		}
	}, [paymentURL]);

	const handleChange = (event) => {
		setChoiceOfPayment(event.target.value);
	};

	useEffect(() => {
		if (isTourist) return;
		if (
			choiceOfPayment === "paypal" &&
			Object.keys(paypalLogInitData).length === 0 &&
			BraintreePaypal.paypalTransactionType !== "VAULTED_PAYPAL_PAYMENT_ALLOWED"
		) {
			document.querySelector("#braintree-paypal-button").click();
		} else if (
			BraintreePaypal.paypalTransactionType === "VAULTED_PAYPAL_PAYMENT_ALLOWED"
		) {
			document.querySelector("#braintree-paypal-loggedin").click();
		}
	}, [choiceOfPayment, isTourist]);

	const handleSubmit = (event) => {
		event.preventDefault();
		const submitPayload = {
			...dataForRedirection,
		};
		if (choiceOfPayment === "newCard") {
			paymentSubmit(submitPayload);
		} else if (choiceOfPayment === "") {
			setErrorPopUpOpen(true);
		}
	};

	const handlerForSubmitButton = (event) => {
		if (isSubmitDisabled) return;
		if (isTourist) {
			paymentSubmit({
				...dataForRedirection,
				email: receiptEmail.trim(),
			});
			return;
		}
		let useSavedAccount;
		if (paypalInitData.vault !== null) {
			useSavedAccount = true;
		} else {
			useSavedAccount = false;
		}
		if (
			choiceOfPayment === "paypal" &&
			Object.keys(paypalSubmitData).length === 0
		) {
			paypalSubmit(
				paypalInitData.key,
				sessionStorage.getItem("transactionToken"),
				paypalInitData.flowId,
				sessionStorage.getItem("nonce"),
				useSavedAccount,
				amount,
				sessionStorage.getItem("deviceData"),
				paypalInitData.vault,
				sessionStorage.getItem("payerEmail"),
			);
		} else {
			handleSubmit(event);
		}
	};

	useEffect(() => {
		if (Object.keys(paypalSubmitData).length !== 0) {
			getDataPaymentPaypal(
				paypalInitData.key,
				paypalSubmitData.transactionToken,
			);
		}
	}, [paypalSubmitData]);

	useEffect(() => {
		if (
			Object.keys(getPaymentPaypalData).length !== 0 &&
			getPaymentPaypalData.success === true &&
			Object.keys(paypalSubmitData).length !== 0
		) {
			handleNext();
		}
	}, [getPaymentPaypalData, paypalSubmitData]);

	$(".paypal-button-content").click(function () {
		console.log(
			"paypalLoginButtonElementId handler for initiatePaypalLogin called!!!",
		);
		document.getElementById("callLoginInit").click();
		// callLoginInit(paypalInit.key, paypalInit.paypalSaveEnabled, paypalInitData.flowId);
	});

	return (
		<Fragment>
			<div id="paypal_login_completed" style={{ display: "none" }}></div>
			<div id="errorPaypalModal" className="modal" style={{ display: "none" }}>
				<div className="modal-content">
					<div className="infoIcon"></div>
					<p>{t("paypalLoginFailed")}</p>
				</div>
			</div>
			<div id="payPalTransactionId" style={{ display: "none" }}></div>
			{/*<div id="idNumber"  style={{display:"none"}}></div>*/}
			<span className="modalTitle">
				{!hideGoBackForTourist && (
					<a
						className="goBack hidden nextStep stepBackAlign"
						onClick={handleBack}
					>
						<i className="symmetry-icon-arrow-right"></i>
					</a>
				)}
				{isTourist ? t("billPayment") : t("paymentAndRenewal")}
			</span>
			<Stepper t={t} activeStep={activeStep} />
			<div className="paymentContent secondStepContent stepsContainer">
				<div className="paymentContentTitle">
					{t(isTourist ? "cardDetailsTourist" : "cardDetails")}
				</div>
				<div className="paymentMethod">
					<div className="paymentMethodCol withBorder flexColumn">
						<FormControl>
							<RadioGroup value={choiceOfPayment} onChange={handleChange}>
								<FormControlLabel
									value="newCard"
									control={<Radio className="paymentByCard" />}
									label={
										<label className="payment-type-method" htmlFor="autoOption">
											<div className="payment-type-method-text">
												<span className="textb">
													{t(
														isTourist
															? "radioLabelPayByCardTourist"
															: "radioLabelPayByCard",
													)}
												</span>
												<br />
												<span>
													{t(isTourist ? "typeOfCardsTourist" : "typeOfCards")}
												</span>
											</div>
										</label>
									}
								/>
								{!isTourist &&
									(Object.keys(paypalInitData).length !== 0 ? (
										<div
											id="paypalDiv"
											className="paymentMethodCol withBorder flexColumn"
										>
											<FormControlLabel
												value="paypal"
												control={<Radio className="paymentByPaypal" />}
												label={
													<label
														className="payment-type-method"
														htmlFor="autoOption"
													>
														<div
															id="paypalLoginButton"
															className="payment-type-method-text"
														>
															<div
																id="callLoginInit"
																onClick={() => {
																	callLoginInit(
																		paypalInit.key,
																		paypalInit.paypalSaveEnabled,
																		paypalInitData.flowId,
																	);
																}}
																style={{ display: "none" }}
															></div>
															<div
																id="payPalNonce"
																style={{ display: "none" }}
															></div>
															<div id="key" style={{ display: "none" }}></div>
															<div
																id="paypalEmail"
																style={{ display: "none" }}
															></div>
															<div
																id="paypalDeviceData"
																style={{ display: "none" }}
															></div>
															<span className="textb">
																{t("radioLabelPayByPaypal")}
															</span>
															<br />{" "}
															<span className="infoText withoutTopMarginText">
																{t("paypalLogIn")}
															</span>
														</div>
													</label>
												}
											/>
										</div>
									) : (
										<div
											id="paypalDiv"
											className="paymentMethodCol withBorder flexColumn "
										>
											<FormControlLabel
												disabled={true}
												value="paypal"
												control={<Radio className="paymentByPaypal disabled" />}
												label={
													<label
														className="payment-type-method"
														htmlFor="autoOption"
													>
														<div
															id="paypalLoginButton"
															className="payment-type-method-text"
														>
															<div
																id="callLoginInit"
																onClick={() => {
																	callLoginInit(
																		paypalInit.key,
																		paypalInit.paypalSaveEnabled,
																		paypalInitData.flowId,
																	);
																}}
																style={{ display: "none" }}
															></div>
															<div
																id="payPalNonce"
																style={{ display: "none" }}
															></div>
															<div id="key" style={{ display: "none" }}></div>
															<div
																id="paypalEmail"
																style={{ display: "none" }}
															></div>
															<div
																id="paypalDeviceData"
																style={{ display: "none" }}
															></div>
															<span className="textb">
																{t("radioLabelPayByPaypal")}
															</span>
															<br />{" "}
															<span className="infoText withoutTopMarginText">
																{t("paypalLogIn")}
															</span>
														</div>
													</label>
												}
											/>
										</div>
									))}
							</RadioGroup>
						</FormControl>
					</div>
				</div>
				{isTourist && (
					<div style={{ marginTop: "16px" }}>
						<TextField
							className="receiptEmailField"
							fullWidth
							variant="outlined"
							value={receiptEmail}
							onChange={(event) => setReceiptEmail(event.target.value)}
							label={t("emailForReceipt")}
							error={receiptEmail.length > 0 && !isValidReceiptEmail}
							helperText={
								receiptEmail.length > 0 && !isValidReceiptEmail
									? t("emailError")
									: ""
							}
						/>
					</div>
				)}
				<div className="buttonOuter inlineButtons rightAligned">
					<a
						className={`button primaryButton primaryButtonNormal${isLoadingSubmit ? " loadingButton" : ""}${isSubmitDisabled ? " disabled" : ""}`}
						onClick={handlerForSubmitButton}
					>
						{t(isTourist ? "continueTourist" : "continue")}
						<span className="loadingSpinner"></span>
					</a>
				</div>
			</div>
			<img
				src={exit}
				className="close"
				onClick={handleClose}
				alt={t("close")}
			/>
			{errorPopUpOpen ? (
				<ErrorPopUp
					setOpenErrorPopUp={setErrorPopUpOpen}
					openErrorPopUp={errorPopUpOpen}
					t={t}
					text={
						errorSubmitPaypal || errorPaypalGetData
							? t("errorGeneral")
							: t("noPaymentMethodSelected")
					}
				/>
			) : null}
		</Fragment>
	);
};
export default PaymentStepTwo;
